import { GTAG_EVENTS, GtagEventKey } from 'shared/constants/analytics'

export const sendGtagEvent = (
  key: GtagEventKey,
  params?: Record<string, unknown>,
) => {
  window.gtag?.('event', GTAG_EVENTS[key], params)
}

export const onPageviewGtagAnalytics = (url: string) => {
  sendGtagEvent('PAGE_VIEW', { page_path: url })
}
